import { useEffect, useRef, useState } from 'react';

export const useTitleMarquee = () => {
  const wrapperRef = useRef<HTMLSpanElement>(null);
  const measureRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const measure = measureRef.current;

    if (!wrapper || !measure) {
      return;
    }

    const check = () => {
      setIsOverflowing(measure.offsetWidth > wrapper.clientWidth);
    };

    const observer = new ResizeObserver(check);
    observer.observe(wrapper);
    check();

    return () => observer.disconnect();
  }, []);

  return { wrapperRef, measureRef, isOverflowing };
};
